import React from 'react'
import SiloBackgroundColor from './SiloBackgroundColor';
import SiloLightingTemperature from './SiloLightingTemperature';
import SiloContactShadows from './SiloContactShadows';

export default function SiloSettingsPresets(props) {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%'
    }}>
        <div style={{
          backgroundColor: 'white',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          width: '90%',
          height: '95%',
          padding: '20px',
          borderRadius: '8px'
        }}>
            <p className='manrope f-16 black' style={{textAlign:"center", marginBottom:"25px"}}>Preset Settings</p>
            <div style={{marginTop:"25px"}}>
                <SiloContactShadows absolutePosition={false} {...props}/>
            </div>
            <div style={{marginTop:"25px"}}>
                <SiloBackgroundColor {...props}/>    
            </div>
            <div style={{marginTop:"25px"}}>
                <SiloLightingTemperature {...props}/>
            </div>
        </div>
    </div>
  )
}
